"use strict";
exports.__esModule = true;
exports.TradeCalculatorMethod = void 0;
var TradeCalculatorMethod;
(function (TradeCalculatorMethod) {
    TradeCalculatorMethod["RebalanceFull"] = "RebalanceFull";
    TradeCalculatorMethod["SpecificSecurities"] = "SpecificSecurities";
    TradeCalculatorMethod["Swap"] = "Swap";
    TradeCalculatorMethod["FullLiquidation"] = "FullLiquidation";
    TradeCalculatorMethod["ContributionUsingTarget"] = "ContributionUsingTarget";
    TradeCalculatorMethod["ContributionUsingCurrent"] = "ContributionUsingCurrent";
    TradeCalculatorMethod["WithdrawalUsingCurrent"] = "WithdrawalUsingCurrent";
    TradeCalculatorMethod["CashFixer"] = "CashFixer";
    TradeCalculatorMethod["Flatten"] = "Flatten";
})(TradeCalculatorMethod = exports.TradeCalculatorMethod || (exports.TradeCalculatorMethod = {}));
